<template>
	<LoginModal
		v-if="isOpen"
		:is-submitting="isSubmitting"
		:auth-error="authError"
		show-features
		@google="signInWithGoogle"
		@microsoft="signInWithOutlook"
		@dismiss="uiStore.dismissWelcome"
	/>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { storeToRefs } from "pinia"
import { useRoute } from "vue-router"
import LoginModal from "@/components/modals/LoginModal.vue"
import { UseRootStore } from "@/model/RootStore"
import { useUIStore } from "@/stores/uiStore"
import { useOAuthSignIn } from "@/composables/useOAuthSignIn"
import { Route } from "@/utils/routing"
import { CtaSource } from "@/utils/ctaSource"

const { isUserLoggedIn } = storeToRefs(UseRootStore())
const uiStore = useUIStore()
const route = useRoute()

const { isSubmitting, authError, signInWithGoogle, signInWithOutlook } = useOAuthSignIn(
	() => route.fullPath,
	CtaSource.WelcomeModal
)

const isOpen = computed(() => !isUserLoggedIn.value && !uiStore.isWelcomeDismissed && route.name === Route.Home)
</script>
